<div class="container mx-auto px-4 mb-3">
    <div class="flex-auto mt-8 p-4 lg:px-10 bg-white rounded-lg" id="main_container">
        <form style="margin-top: 1%;">
            <h6 class="text-center text-gray-400 text-sm my-6 font-bold uppercase" id="field">
                {{ 'CROP.FIELD' | translate }}
            </h6>
            <hr class="my-4 border-b-1 border-gray-300" />
            <div class="flex flex-wrap">
                <div class="w-full lg:w-4/12 px-4">
                    <div class="relative w-full mb-3">
                        <label class="block uppercase text-gray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                            {{ 'CROP.CODE' | translate }}
                        </label>
                        <div *ngIf="!this.data"
                            class="card border-1 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150">
                            <mat-select [(ngModel)]="plotCode" [ngModelOptions]="{standalone: true}">
                                <mat-option *ngFor="let code of plotCodes" [value]="code">
                                    {{ code[0] }} - {{ code[1] }}
                                </mat-option>
                            </mat-select>
                        </div>
                        <div *ngIf="this.data">
                            <input type="text"
                                class="border-2 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                [value]="editPlotCode" disabled>
                        </div>
                    </div>
                </div>
                <div class="w-full lg:w-4/12 px-4">
                    <div class="relative w-full mb-3">
                        <label class="block uppercase text-gray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                            {{ 'CROP.DATETIME' | translate }}
                        </label>
                        <input type="date"
                            class="border-2 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                            [(ngModel)]="date" name="date" />
                    </div>
                </div>
                <div class="w-full lg:w-4/12 px-4">
                    <div class="relative w-full mb-3">
                        <label class="block uppercase text-gray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                            {{ 'CROP.OPERATOR' | translate }}
                        </label>
                        <input type="text" autocomplete="off"
                            class="border-2 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                            [(ngModel)]="operator" name="operator" />
                    </div>
                </div>
            </div>
        </form>
        <div *ngFor="let trap of traps; let i = index">
            <form style="margin-top: 1%;">
                <h6 class="text-center text-gray-400 text-sm my-3 font-bold uppercase" id="traps">
                    {{ 'DACUS.TRAPS' | translate }}
                </h6>
                <hr class="my-4 border-b-1 border-gray-300" />
                <div class="flex flex-wrap w-full">
                    <div class="w-full lg:w-2/12 px-4">
                        <div class="relative w-full mb-3">
                            <label class="block uppercase text-gray-600 text-xs font-bold mb-2" [for]="'node' + i">
                                {{'DACUS.TRAP' | translate }}
                            </label>
                            <input type="text" autocomplete="off"
                                class="border-2 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                [(ngModel)]="trap.name" [name]="'node' + i" />
                        </div>
                    </div>
                    <div class="w-full lg:w-2/12 px-4">
                        <div class="relative w-full mb-3">
                            <label class="block uppercase text-gray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                                {{ 'DACUS.TYPE' | translate }}
                            </label>
                            <div *ngIf="!this.data"
                                class="card border-1 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150">
                                <mat-select [(ngModel)]="trap.type" [ngModelOptions]="{standalone: true}">
                                    <mat-option value="McPhail">
                    McPhail
                                    </mat-option>
                                </mat-select>
                            </div>
                            <div *ngIf="this.data">
                                <input type="text" autocomplete="off"
                                    class="border-2 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                    [(ngModel)]="trap.type" [ngModelOptions]="{standalone: true}" disabled />
                            </div>
                        </div>
                    </div>
                    <div class="w-full lg:w-2/12 px-4">
                        <div class="relative w-full mb-3">
                            <label class="block uppercase text-gray-600 text-xs font-bold mb-2"
                                htmlFor="grid-password">
                                {{ 'CROP.RELATED_ACTION' | translate }}
                            </label>
                            <div
                                class="card border-1 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150">
                                <mat-select [(ngModel)]="trap.relatedAction" [ngModelOptions]="{standalone: true}"
                                    >
                                    <mat-option *ngFor="let action of relatedActions" [value]="action">
                                        {{ action }}
                                    </mat-option>
                                </mat-select>
                            </div>
                        </div>
                    </div>
                    <div class="w-full lg:w-3/12 px-4">
                        <div class="relative w-full mb-3">
                            <label class="block uppercase text-gray-600 text-xs font-bold mb-2" [for]="'latitude' + i">
                                {{'PLOTS.LAT' | translate }}
                            </label>
                            <input type="number" min="0" step="0.00001" autocomplete="off"
                                class="border-2 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                [(ngModel)]="trap.lat" [name]="'latitude' + i" [id]="'latitude' + i" />
                        </div>
                    </div>
                    <div class="w-full lg:w-3/12 px-4">
                        <div class="relative w-full mb-3">
                            <label class="block uppercase text-gray-600 text-xs font-bold mb-2" [for]="'longitude' + i">
                                {{'PLOTS.LON' | translate }}
                            </label>
                            <input type="number" min="0" step="0.00001" autocomplete="off"
                                class="border-2 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                [(ngModel)]="trap.lon" [name]="'longitude' + i" [id]="'longitude' + i" />
                        </div>
                    </div>
                </div>
            </form>
            <mat-expansion-panel style="margin-top: 1%;" *ngIf="trap.measurements?.length > 0">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <h6 class="text-center text-gray-400 text-sm my-3 font-bold uppercase" id="measurements">
                            {{ 'DACUS.MEASUREMENTS' | translate }}
                        </h6>
                    </mat-panel-title>
                    <mat-panel-description></mat-panel-description>
                </mat-expansion-panel-header>
                <form style="margin-top: 1%;" *ngFor="let measurement of trap.measurements; let j = index" class="my-8 shadow-md">
                    <hr class="my-3 border-b-1 border-gray-300" />
                    <div class="flex flex-wrap w-full">
                        <div class="w-full lg:w-4/12 px-4">
                            <div class="relative w-full mb-3">
                                <label class="block uppercase text-gray-600 text-xs font-bold mb-2">
                                    {{ 'DACUS.DATE' | translate }}
                                </label>
                                <input type="date"
                                    class="border-2 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                    [(ngModel)]="measurement.measurementDate" name="date{{j}}" />
                            </div>
                        </div>
                        <div class="w-full lg:w-4/12 px-4">
                            <div class="relative w-full mb-3">
                                <label class="block uppercase text-gray-600 text-xs font-bold mb-2">
                                    {{ 'DACUS.ACTION' | translate }}
                                </label>
                                <div *ngIf="!measurement.editActions"
                                    class="border-2 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                    (click)="enableEdit(measurement)">
                                    {{ measurement?.action.length ? translatedActions(measurement).join(', ') : 'No actions selected' }}
                                </div>
                                <div *ngIf="measurement.editActions"
                                    class="card border-1 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150">
                                    <mat-select [(ngModel)]="measurement.action" [ngModelOptions]="{standalone: true}"
                                        multiple (closed)="disableEdit(measurement)">
                                        <mat-option *ngFor="let action of actions" [value]="action">
                                            {{ action | translate }}
                                        </mat-option>
                                    </mat-select>
                                </div>
                            </div>
                        </div>
                        <div class="w-full lg:w-4/12 px-4">
                            <div class="relative w-full mb-3">
                                <label class="block uppercase text-gray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                                    {{ 'DACUS.INSECT' | translate }}
                                </label>
                                <div
                                    class="card border-1 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150">
                                    <mat-select [(ngModel)]="measurement.insectType" [ngModelOptions]="{standalone: true}">
                                        <mat-option *ngFor="let type of insectTypes" [value]="type">
                                            {{ type }}
                                        </mat-option>
                                    </mat-select>
                                </div>
                            </div>
                        </div>
                        <div class="w-full lg:w-3/12 px-4">
                            <div class="relative w-full mb-3">
                                <label class="block uppercase text-gray-600 text-xs font-bold mb-2">
                                    {{ 'DACUS.TOTAL_FLY' | translate }}
                                </label>
                                <input type="number" min="0" step="1"
                                    class="border-2 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                    [(ngModel)]="measurement.totalFlies" name="flies" />
                            </div>
                        </div>
                        <div class="w-full lg:w-3/12 px-4">
                            <div class="relative w-full mb-3">
                                <label class="block uppercase text-gray-600 text-xs font-bold mb-2">
                                    {{ 'DACUS.MALE_FLY' | translate }}
                                </label>
                                <input type="number" min="0" step="1"
                                    class="border-2 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                    [(ngModel)]="measurement.totalMales" name="maleflies{{j}}" />
                            </div>
                        </div>
                        <div class="w-full lg:w-3/12 px-4">
                            <div class="relative w-full mb-3">
                                <label class="block uppercase text-gray-600 text-xs font-bold mb-2">
                                    {{ 'DACUS.FEMALE_FLY' | translate }}
                                </label>
                                <input type="number" min="0" step="1"
                                    class="border-2 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                    [(ngModel)]="measurement.totalFemales" name="femaleflies{{j}}" />
                            </div>
                        </div>
                        <div class="w-full lg:w-3/12 px-4">
                            <div class="relative w-full mb-3">
                                <label class="block uppercase text-gray-600 text-xs font-bold mb-2">
                                    {{ 'DACUS.DISEASE' | translate }}
                                </label>
                                <input type="number" min="0" step="1"
                                    class="border-2 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                    [(ngModel)]="measurement.diseaseCount" name="diseaseCount{{j}}" />
                            </div>
                        </div>
                        <div class="w-full lg:w-2/12 px-4">
                            <div class="relative w-full mb-3">
                                <label class="block uppercase text-gray-600 text-xs font-bold mb-2">
                                    {{ 'DACUS.LARVA' | translate }}
                                </label>
                                <input type="number" min="0" step="0.01"
                                    class="border-2 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                    [(ngModel)]="measurement.larva" name="larva{{j}}" />
                            </div>
                        </div>
                        <div class="w-full lg:w-10/12 px-4">
                            <div class="relative w-full mb-3">
                                <label class="block uppercase text-gray-600 text-xs font-bold mb-2">
                                    {{ 'DACUS.COMMENTS' | translate }}
                                </label>
                                <input type="text"
                                    class="border-2 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                    [(ngModel)]="measurement.comments" name="comments{{j}}" />
                            </div>
                        </div>
                    </div>
                    <button *ngIf="!isExistingMeasurement(measurement)" type="button" (click)="removeMeasurement(i, j)"
                        class="m-2 mt-4" matTooltip="{{ 'DACUS.TOOLTIP_DELETE_MEASUREMENT' | translate }}">
                        <i class="fas fa-minus text-md"></i>
                    </button>
                </form>
            </mat-expansion-panel>
            <mat-expansion-panel style="margin-top: 1%;" *ngIf="!data">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <h6 class="text-center text-gray-400 text-sm my-3 font-bold uppercase" id="measurements">
                            {{ 'DACUS.MEASUREMENTS' | translate }}
                        </h6>
                    </mat-panel-title>
                    <mat-panel-description></mat-panel-description>
                </mat-expansion-panel-header>
                <form style="margin-top: 1%;">
                    <hr class="my-3 border-b-1 border-gray-300" />
                    <div class="flex flex-wrap w-full">
                        <div class="w-full lg:w-4/12 px-4">
                            <div class="relative w-full mb-3">
                                <label class="block uppercase text-gray-600 text-xs font-bold mb-2"
                                    htmlFor="grid-password">
                                    {{ 'DACUS.DATE' | translate }}
                                </label>
                                <input type="date"
                                    class="border-2 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                    [(ngModel)]="trap.measurementDate" name="date" />
                            </div>
                        </div>
                        <div class="w-full lg:w-4/12 px-4">
                            <div class="relative w-full mb-3">
                                <label class="block uppercase text-gray-600 text-xs font-bold mb-2"
                                    htmlFor="grid-password">
                                    {{ 'DACUS.ACTION' | translate }}
                                </label>
                                <div
                                    class="card border-1 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150">
                                    <mat-select [(ngModel)]="trap.action" [ngModelOptions]="{standalone: true}"
                                        multiple>
                                        <mat-option *ngFor="let action of actions" [value]="action">
                                            {{ action | translate }}
                                        </mat-option>
                                    </mat-select>
                                </div>
                            </div>
                        </div>
                        <div class="w-full lg:w-4/12 px-4">
                            <div class="relative w-full mb-3">
                                <label class="block uppercase text-gray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                                    {{ 'DACUS.INSECT' | translate }}
                                </label>
                                <div
                                    class="card border-1 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150">
                                    <mat-select [(ngModel)]="trap.insectType" [ngModelOptions]="{standalone: true}">
                                        <mat-option *ngFor="let type of insectTypes" [value]="type">
                                            {{ type }}
                                        </mat-option>
                                    </mat-select>
                                </div>
                            </div>
                        </div>
                        <div class="w-full lg:w-3/12 px-4">
                            <div class="relative w-full mb-3">
                                <label class="block uppercase text-gray-600 text-xs font-bold mb-2"
                                    htmlFor="grid-password">
                                    {{ 'DACUS.TOTAL_FLY' | translate }}
                                </label>
                                <input type="number" min="0" step="1"
                                    class="border-2 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                    [(ngModel)]="trap.totalFlies" name="flies" />
                            </div>
                        </div>
                        <div class="w-full lg:w-3/12 px-4">
                            <div class="relative w-full mb-3">
                                <label class="block uppercase text-gray-600 text-xs font-bold mb-2"
                                    htmlFor="grid-password">
                                    {{ 'DACUS.MALE_FLY' | translate }}
                                </label>
                                <input type="number" min="0" step="1"
                                    class="border-2 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                    [(ngModel)]="trap.totalMales" name="flies" />
                            </div>
                        </div>
                        <div class="w-full lg:w-3/12 px-4">
                            <div class="relative w-full mb-3">
                                <label class="block uppercase text-gray-600 text-xs font-bold mb-2"
                                    htmlFor="grid-password">
                                    {{ 'DACUS.FEMALE_FLY' | translate }}
                                </label>
                                <input type="number" min="0" step="1"
                                    class="border-2 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                    [(ngModel)]="trap.totalFemales" name="flies" />
                            </div>
                        </div>
                        <div class="w-full lg:w-3/12 px-4">
                            <div class="relative w-full mb-3">
                                <label class="block uppercase text-gray-600 text-xs font-bold mb-2"
                                    htmlFor="grid-password">
                                    {{ 'DACUS.DISEASE' | translate }}
                                </label>
                                <input type="number" min="0" step="1"
                                    class="border-2 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                    [(ngModel)]="trap.diseaseCount" name="diseaseCount" />
                            </div>
                        </div>
                        <div class="w-full lg:w-2/12 px-4">
                            <div class="relative w-full mb-3">
                                <label class="block uppercase text-gray-600 text-xs font-bold mb-2"
                                    htmlFor="grid-password">
                                    {{ 'DACUS.LARVA' | translate }}
                                </label>
                                <input type="number" min="0" step="0.01"
                                    class="border-2 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                    [(ngModel)]="trap.larva" name="larva" />
                            </div>
                        </div>
                        <div class="w-full lg:w-10/12 px-4">
                            <div class="relative w-full mb-3">
                                <label class="block uppercase text-gray-600 text-xs font-bold mb-2"
                                    htmlFor="grid-password">
                                    {{ 'DACUS.COMMENTS' | translate }}
                                </label>
                                <input type="text"
                                    class="border-2 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                    [(ngModel)]="trap.comments" name="comments" />
                            </div>
                        </div>
                    </div>
                </form>
            </mat-expansion-panel>
            <button *ngIf="!this.data" type="button" (click)="removeTrap(i)" [hidden]="isDeleteDisabled()"
                class="m-2 mt-4" matTooltip='{{ "DACUS.TOOLTIP_DELETE" | translate }}'><i
                    class="fas fa-minus text-md"></i>
            </button>
            <button *ngIf="this.data" type="button" (click)="addMeasurement(i)" class="m-2 mt-4">
                <i class="fas fa-plus text-md" matTooltip="{{ 'DACUS.TOOLTIP_ADD_MEASUREMENT' | translate }}"></i>
            </button>
        </div>
        <button *ngIf="!this.data" type="button" (click)="addTrap()" class="m-2 mt-4"><i class="fas fa-plus text-md"
                matTooltip='{{ "DACUS.TOOLTIP_ADD" | translate }}'></i>
        </button>
    </div>
    <button mat-raised-button id="saveButton" class="float-right m-2" type="button" (click)="saveOrUpdateTrap()">
        <mat-icon>done</mat-icon>
        {{ 'MANAGEMENT.SAVE' | translate }}
    </button>
</div>